module.exports = __webpack_public_path__ + "img/search.5002063a.svg";